import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M15.0667 5L16 5.92453L9.86667 12L16 18.0755L15.0667 19L8 12L15.0667 5Z" fill="#3C101E" />
    </Icons>
  );
}
